<template>
  <v-expansion-panels
    class="filter-bar"
    :flat="flat"
    :value="value ? 0 : undefined"
    @change="$emit('input', $event !== undefined)"
  >
    <v-expansion-panel :readonly="hideFilter">
      <v-expansion-panel-header class="py-0" :hide-actions="hideFilter">
        <v-toolbar dense flat class="filter-bar__toolbar">
          <v-toolbar-title>
            {{ label }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <slot name="toolbar"></slot>
          <template v-for="item in toolbarItems">
            <template v-if="item.type === 'static'">
              <v-icon small left :key="item.id">{{ item.icon }}</v-icon>
              <span :key="item.id" class="text-button">{{ item.title }}</span>
            </template>
            <v-tooltip
              :class="'itus-button-' + item.id"
              v-else-if="!item.hasSub"
              bottom
              :open-delay="500"
              :key="item.id"
              :disabled="!item.tooltip"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  exact
                  text
                  icon
                  color="secondary"
                  active-class
                  :id="item.id"
                  v-bind:disabled="item.disabled"
                  v-on:click.native.stop="item.click"
                  v-on="on"
                >
                  <v-icon v-if="item.icon" small :left="!!item.title">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-btn>
              </template>
              {{ item.tooltip }}
            </v-tooltip>
            <v-menu v-else :key="item.id" @click.stop bottom offset-y>
              <template v-slot:activator="{ on: menu }">
                <v-tooltip bottom :open-delay="500" :disabled="!item.tooltip">
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      v-on="{ ...tooltip, ...menu }"
                      small
                      exact
                      :text="!!item.title"
                      icon
                      color="secondary"
                      v-bind:disabled="item.disabled"
                      :id="item.id"
                    >
                      <v-icon small :left="!!item.title">{{ item.icon }}</v-icon>
                      {{ item.title }}
                    </v-btn>
                  </template>
                  {{ item.tooltip }}
                </v-tooltip>
              </template>
              <v-list>
                <template v-for="subitem in toolbarSubItems">
                  <v-list-item
                    v-if="item.id === subitem.parentId"
                    :key="subitem.id"
                    v-bind:id="subitem.id"
                    v-bind:disabled="subitem.disabled"
                    @click.capture.stop="subitem.click"
                  >
                    <v-list-item-icon v-if="subitem.icon">
                      <v-icon>{{ subitem.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      {{ subitem.title }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
          <div v-if="!hideFilter" class="ml-2 text-right">Filter</div>
        </v-toolbar>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'FilterBar',
  props: {
    value: {
      type: Boolean,
      description: 'true when expanded'
    },
    label: {
      type: String,
      description: 'Label to go in the toolbar title'
    },
    flat: {
      type: Boolean
    },
    toolbarItems: {
      type: Array,
      description:
        'Array of items to generate in the toolbar. Can alternatively use the toolbar slot to pass in custom stuff.'
    },
    toolbarSubItems: {
      type: Array,
      description: 'Array of menu items for the top-level items that need them.'
    },
    hideFilter: {
      type: Boolean,
      default: false,
      description: 'Hide "Filter" and the expand icon in the header, prevent expansion-panel from being opened'
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-bar__toolbar ::v-deep {
  .v-toolbar__content {
    padding: 0;
  }
}
</style>
